import { modalConstants } from '../../constants'

export const modalActions = {
    showModalBagic,
    clearModal
}

function showModalBagic(params, orgparams) {
    return {
        type: modalConstants.MODAL_BAGIC,
        params,
        orgparams
    }
}

function clearModal() {
    return {
        type: modalConstants.MODAL_CLEAR
    }
}